import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

import { OrganizationService } from '../../../../../services/organization/organization.service';
import { UserSettingsService } from '../../../../../services/members/user-settings.service';

import { AutopayActivatorComponent } from './autopay-activator.component';
import { CurrencyInputModule } from '../../../../shared/currency-input/currency-input.module';
import { FormMessagesModule } from '../../../../shared/form-messages/form-messages.module';
import { PaymentMethodSelectorModule } from '../../payment-method-selector/payment-method-selector.module';
import { LegfiBalancePipeModule } from '../../../../../pipes/format/legfi-balance.module';
import { LegfiBalancePipe } from '../../../../../pipes/format/legfi-balance.pipe';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        CurrencyInputModule,
        FormMessagesModule,
        LegfiBalancePipeModule,
        PaymentMethodSelectorModule,
        LegfiCurrencyPipeModule,
        MatCheckboxModule,
    ],
    declarations: [AutopayActivatorComponent],
    exports: [AutopayActivatorComponent],
    providers: [
        LegfiBalancePipe,
        // Services
        OrganizationService,
        UserSettingsService,
    ],
})
export class AutopayActivatorModule
{
}
